// extracted by mini-css-extract-plugin
export default {"price":"rqa-z","onSale":"sqa-z","msrpLabelPrice":"tqa-z","msrpLabel":"uqa-z","originalPrice":"vqa-z"};